

export default {
  featured_trending: "🔥 المنتجات الرائجة",
  featured_recommended: "🛒 موصى به لك",
  featured_best_deals: "⚡ أفضل العروض الآن",
  view_all: "عرض الكل",
  loading: "جار التحميل...",
 

// CategoryBar


  cat_all: "الكل",
  cat_fresh: "طازج",
  cat_vegetables: "الخضروات",
  cat_rice: "الأرز",
  cat_meat: "اللحوم",
  cat_dairy: "الألبان",
  cat_offers: "العروض",

//   Header

      fetching_location: "جارٍ جلب الموقع...",
  search_ingredients_products: "ابحث عن المكونات أو المنتجات...",
  recent: "الأخيرة",
  my_profile: "ملفي الشخصي",

 
//   CategoryWise

  shop_by_category: "تسوق حسب الفئة",
  cat_vegetables: "الخضروات",
  cat_fruits: "الفواكه",
  cat_rice: "الأرز",
  cat_meat: "اللحوم",
  cat_dairy_products: "منتجات الألبان",
  cat_spices: "التوابل",
  cat_oils: "الزيوت",

  // MahalIntentSection
  what_are_you_ordering_today: "ماذا تطلب اليوم؟",
  choose_kitchen_needs: "اختر ما يحتاجه مطبخك الآن",
  cat_vegetables: "الخضروات",
  cat_fruits: "الفواكه",
  cat_dairy_products: "منتجات الألبان",
  cat_meat_poultry: "اللحوم والدواجن",
  cat_seafood: "المأكولات البحرية",
  cat_rice_grains: "الأرز والحبوب",
  cat_lentils_pulses: "العدس والبقوليات",
  cat_spices_masalas: "التوابل والبهارات",
  cat_edible_oils: "زيوت الطعام",
  cat_packaging_materials: "مواد التعبئة والتغليف",
  cat_grains_pulses: "الحبوب والبقوليات",
  cat_spices_herbs: "التوابل والأعشاب",
  cat_rice: "الأرز",
  cat_wheat_flour: "دقيق القمح",
  cat_lentils: "العدس",
  cat_pulses: "البقوليات",
  cat_grains: "الحبوب",
  cat_edible_oils_frozen_ready: "زيوت الطعام / المنتجات المجمدة والجاهزة",

  // HotDealsSection

    up_to: "حتى",
  off: "خصم",
  limited_time_procurement_deals: "عروض المشتريات لفترة محدودة",
  ends_in: "ينتهي خلال",
  add: "إضافة",
  login_required: "تسجيل الدخول مطلوب",
  product_already_cart: "المنتج موجود بالفعل في السلة 🛒\n\nتم تحديث الكمية",
  added_to_cart: "✅ تمت الإضافة إلى السلة",
  add_to_cart_failed: "فشل في الإضافة إلى السلة",
    "qar": "ر.ق",
  "buy": "اشترِ",
  "hour": "ساعة",
  "minute": "دقيقة",
  "second": "ثانية",

  // VerifiedSuppliers

    verified_suppliers: "الموردون المعتمدون",
  trusted_partners_procurement: "شركاء موثوقون يدعمون مشتريات المطاعم",
  verified: "معتمد",
  fast_delivery: "توصيل سريع",
  min_order_5000: "الحد الأدنى للطلب ₹5000",
  view_supplier: "عرض المورد",
  "qar": "ر.ق",
"min_order": "الحد الأدنى للطلب",
"min_order_5000": "الحد الأدنى للطلب ر.ق ٥٠٠٠",
"fast_delivery": "توصيل سريع",
"verified_suppliers": "موردون موثوقون",

  //Mahal Deals Of The Day
deals_of_the_day: "عروض اليوم",
limited_time_offers_verified_suppliers: "عروض لفترة محدودة من موردين معتمدين",
loading_deals: "جارٍ تحميل العروض...",
please_login: "يرجى تسجيل الدخول",
backend_error: "خطأ في الخادم",
failed_update_cart: "فشل في تحديث السلة",
add_to_cart: "أضف إلى السلة",
ends_in: "ينتهي خلال",
product_already_cart: "المنتج موجود بالفعل في السلة 🛒\n\nتم تحديث الكمية",
added_to_cart: "✅ تمت الإضافة إلى السلة",
login_required: "تسجيل الدخول مطلوب",
"qar": "ر.ق",
"hour": "ساعة",
"minute": "دقيقة",
"second": "ثانية",

// MahalSponsoredSecion

supplier_spotlight: "تسليط الضوء على الموردين",
trusted_suppliers_limited_offers: "موردون موثوقون • عروض لفترة محدودة",
ends_in_upper: "ينتهي خلال",
view_product: "عرض المنتج",
verified_supplier: "مورد معتمد",
qar: "ر.ق",
"hour": "ساعة",
"minute": "دقيقة",
"second": "ثانية",


// PromoStrip

promo_bulk_rice_offers: "عروض الأرز بالجملة",
promo_up_to_20_off: "خصم يصل إلى ٢٠٪",
promo_meat_deals: "عروض اللحوم",
promo_fresh_frozen: "طازج ومجمد",
promo_daily_essentials: "الاحتياجات اليومية",
promo_best_prices: "أفضل الأسعار",
promo_view_products: "عرض المنتجات",

// MahalStealDeals

steal_deals_for_you: "عروض مميزة لك",
qar: "ر.ق",
error: "حدث خطأ",
"special_offer": "عرض خاص",
"off": "خصم",

// BestSellProducts

best_selling_offers: "أفضل العروض مبيعًا",
top_deals_for_you: "أفضل العروض لك",
hot_deals: "عروض ساخنة",
save_big_today_offers: "وفّر أكثر على عروض اليوم",
shop_now: "تسوق الآن",
off: "خصم",
qar: "ر.ق",
please_login: "يرجى تسجيل الدخول",
product_already_cart: "المنتج موجود بالفعل في السلة 🛒\n\nتم تحديث الكمية",
added_to_cart: "تمت الإضافة إلى السلة 🛒",
backend_error: "خطأ في الخادم",

// NewProducts

trending_now: "الرائج الآن",
discover_loving_today: "اكتشف ما يحبه الناس اليوم",
loading_products: "جارٍ تحميل المنتجات...",
new: "جديد",
view_product: "عرض المنتج",
please_login: "يرجى تسجيل الدخول",
product_already_cart: "المنتج موجود بالفعل في السلة 🛒\n\nتم تحديث الكمية",
added_to_cart: "تمت الإضافة إلى السلة 🛒",
backend_error: "خطأ في الخادم",
added_to_wishlist: "تمت الإضافة إلى المفضلة ❤️",
already_in_wishlist: "موجود بالفعل في المفضلة",
wishlist_backend_error: "خطأ في خادم المفضلة",

// OffersBanner

fresh_deals: "عروض طازجة",
fresh_essentials_delivered: "توصيل المنتجات الطازجة إلى بابك",
shop_vegetables_fruits: "تسوق الخضروات والفواكه والمواد اليومية بأفضل الأسعار.",
digital_ordering: "الطلب الرقمي",
order_smarter_mahal_app: "اطلب بذكاء مع تطبيق محل",
browse_compare_suppliers: "تصفح وقارن الموردين وأدر طلبات الجملة في مكان واحد.",
fast_delivery: "توصيل سريع",
fast_reliable_bulk_deliveries: "توصيل سريع وموثوق للطلبات الكبيرة",
warehouse_to_kitchen: "من المستودع إلى المطبخ — في الوقت المحدد دائمًا.",
search_products_suppliers: "ابحث عن المنتجات أو الموردين...",
search: "بحث",
explore_now: "استكشف الآن",
download_app: "تحميل التطبيق",
summer_offer: "عرض الصيف",
healthy_organic_food: "طعام عضوي صحي",
special_offer: "عرض خاص",
fresh_organic_food: "طعام عضوي طازج",
shop_now: "تسوق الآن",

// AddBannerSection

limited_offer: "عرض محدود",
offer_banner_1_title: "خصم يصل إلى 50٪ على منتج خاص",
offer_banner_1_desc: "تسوق مجموعتنا من الخضروات العضوية الطازجة بسعر مخفض. خصم 50٪",
offer_banner_2_title: "احصل على خصم 10٪ على الفواكه",
offer_banner_2_desc: "تسوق مجموعتنا من الخضروات العضوية الطازجة بسعر مخفض. خصم 10٪",
offer_banner_3_title: "احصل على خضروات عضوية بخصم 75٪",
offer_banner_3_desc: "تسوق مجموعتنا من الخضروات العضوية الطازجة بسعر مخفض. خصم 75٪",
explore_now: "استكشف الآن",

// FreshProducts

our_fresh_products: "منتجاتنا الطازجة",
no_products_found: "لم يتم العثور على منتجات",
please_login: "يرجى تسجيل الدخول",
backend_error: "خطأ في الخادم",
added_to_wishlist: "تمت الإضافة إلى قائمة الرغبات ❤️",
already_in_wishlist: "موجود بالفعل في قائمة الرغبات",
wishlist_backend_error: "خطأ في قائمة الرغبات",
qar: "ر.ق",

// SpecialProducts

special_products: "منتجات خاصة",
exclusive_deals_kitchen: "عروض حصرية لمطبخك",
weekly_discounts: "خصومات أسبوعية",
fresh_fruits_vegetables: "فواكه وخضروات طازجة",
save_more_bulk: "وفر أكثر عند الشراء بالجملة.",
invalid_product: "منتج غير صالح ❌",
new: "جديد",

// categoriesSection

loading_products: "جاري تحميل المنتجات...",
add: "إضافة",
qar: "ر.ق",
please_login: "يرجى تسجيل الدخول",
product_already_cart: "المنتج موجود بالفعل في السلة 🛒\n\nتم تحديث الكمية",
added_to_cart: "تمت الإضافة إلى السلة ✅",
backend_error: "خطأ في الخادم",
"kg": "كيلوغرام",
"gram": "غرام",
"box": "علبة",
"piece": "قطعة",
"pcs": "قطع",
"unit": "وحدة",

// DeliveryStrip

  "b2b_bulk_orders": "طلبات الشركات والجملة",
  "same_day": "توصيل في نفس اليوم",
  "scheduled_delivery": "وتوصيل مجدول",
  "delivery_time": "10:00 صباحًا – 08:00 مساءً",
  "reliable_delivery_for": "توصيل موثوق لليوم التالي لـ",
  "business_types": "المطاعم وتجار التجزئة والمقاهي ومشتري الجملة",
  "delivery_description": "مصمم للشركات التي تحتاج إلى السرعة والاستمرارية والطزاجة.",
  "read_more": "اقرأ المزيد",
  "contact_sales": "تواصل مع المبيعات",

// Footer

  "mahal": "محل",
  "footer_description": "هو سوق B2B يربط المطاعم بالموردين الموثوقين لاحتياجات المطبخ اليومية والطلبات بالجملة.",
  "marketplace": "السوق",
  "restaurant_offers": "عروض المطاعم",
  "browse_categories": "تصفح الفئات",
  "find_suppliers": "البحث عن الموردين",
  "restaurants": "المطاعم",
  "for_restaurants": "للمطاعم",
  "restaurant_login": "تسجيل دخول المطعم",
  "restaurant_dashboard": "لوحة تحكم المطعم",
  "my_orders": "طلباتي",
  "inventory": "المخزون",
  "for_suppliers": "للموردين",
  "supplier_login": "تسجيل دخول المورد",
  "supplier_dashboard": "لوحة تحكم المورد",
  "manage_products": "إدارة المنتجات",
  "manage_orders": "إدارة الطلبات",
  "support_company": "الدعم والشركة",
  "about_mahal": "حول محل",
  "contact_support": "اتصل بالدعم",
  "help_center": "مركز المساعدة",
  "documentation": "التوثيق",
  "all_rights_reserved": "جميع الحقوق محفوظة",
  "secure_payments": "مدفوعات آمنة",

  // Topbar

  "free_delivery_qatar": "توصيل مجاني في جميع أنحاء قطر",
"verified_suppliers": "موردون موثوقون 100%",
"fast_order_processing": "معالجة سريعة للطلبات",
"download_mahal_app": "حمّل تطبيق محل للجوال",

};